import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import FileUploader from '../../containers/FileUploader';
import formatPath from '../../../utils/textFormaters/formatPath';

const AddendumFileUploaderController = ({
  value,
  error,
  companyId,
  handleUpdate,
  handleDownload,
  handleDelete,
  uploaderTitle,
  uploadUrl,
  editable,
  disabled,
}) => {
  const url = formatPath(uploadUrl, { companyId });

  const maxFileSizeUpload = useSelector(store => store.settings.settings.data.maxFileSizeMb);

  const { loading } = useSelector(store => store.addendumFile.addendumFile);

  const files = useMemo(() => value.map(x => ({...x, id: x.fileId, description: x.fileName})), [value]);

  return (
    <FileUploader
      url={url}
      editable={editable}
      error={error}
      hasPermissions={true}
      maxFileSize={maxFileSizeUpload}
      uploaderTitle={uploaderTitle}
      expirationDate={false}
      cardTitle={''}
      files={files}
      downloadList={[]}
      deleteList={[]}
      loading={loading}
      handleDownload={handleDownload}
      handleSaveFiles={handleUpdate}
      handleDelete={handleDelete}
      disabled={disabled}
    />
  );
};

export default AddendumFileUploaderController;
